import type { StorageBinLabelData } from "./types";

/**
 * QR content of a storage-bin label (FIX-319): `BIN:` plus the first 16 hex
 * characters of the bin's id, for example `BIN:3F2A9C10B7E44D21`.
 *
 * A scan of this content selects exactly that bin, also when its code exists
 * in two storage locations. It is 20 uppercase alphanumeric characters, the
 * most a version-1 QR code holds at error correction M, so the QR code stays
 * the same size as with the old code-only content and fits every template.
 * Labels printed before FIX-319 carry only the bin code; scans still accept it.
 */
export const BIN_QR_PREFIX = "BIN:";
export const BIN_QR_ID_LENGTH = 16;

export function binQrValue(binId: string): string {
  return BIN_QR_PREFIX + binIdKey(binId);
}

/** The id characters a bin QR carries: hyphens removed, uppercase, first 16. */
export function binIdKey(binId: string): string {
  return binId.replace(/-/g, "").slice(0, BIN_QR_ID_LENGTH).toUpperCase();
}

export interface StorageBinForLabel {
  id: string;
  address: string;
  description?: string | null;
}

export function storageBinToLabelData(
  bin: StorageBinForLabel,
  options: { locationName?: string | null; footer?: string } = {},
): StorageBinLabelData {
  return {
    qrValue: binQrValue(bin.id),
    binCode: bin.address,
    locationName: options.locationName,
    description: bin.description,
    footer: options.footer,
  };
}
